export default {
  data(){
     return {
       outputAudioNode: null,
       audioOutputValue: null,
     }
  },
  computed:{
    selectedAudioOutputDevice(){
      return this.$store.state.media.audioOutputDevice;
    }
  },
  mounted(){

  },
  methods : {
    initOutputMonitoring() {
      var AudioContext = window.AudioContext // Default
        || window.webkitAudioContext // Safari and old versions of Chrome
        || false;
      this._audioContext = new AudioContext;
      this.outputAudioNode = this._audioContext.createMediaElementSource(this._audio);
      this._audioProcessor = this._audioContext.createScriptProcessor(2048, 1, 1);
      this.outputAudioNode.connect(this._audioProcessor);
      this._audioProcessor.connect(this._audioContext.destination);
    },
    monitorOutputAudio() {
      this._audioProcessor.onaudioprocess = (e) => {
        const buffer = e.inputBuffer.getChannelData(0);
        const out = e.outputBuffer.getChannelData(0);
        let amp = 0;
        for (let i = 0; i < buffer.length; i++) {
          const loud = Math.abs(buffer[i]);
          if (loud > amp) {
            amp = loud;
          }
          out[i] = buffer[i];
        }
        this._output = amp * 100;
        this._outputInterval = setInterval(() => {
          this.audioOutputValue = this._output;
        }, 100);
      };
    },
    stopOutputMonitoring() {
      clearInterval(this._outputInterval);
      if (this._audioProcessor) {
        this._audioProcessor.disconnect();
        this._audioProcessor = null;
      }
      if (this.outputAudioNode) {
        this.outputAudioNode.disconnect();
        this.outputAudioNode = null;
      }
      if (this._audioContext) {
        this._audioContext = null;
      }
      this._output = 0;
      this.audioOutputValue = 0;
    },
  },
  beforeDestroy() {
    this.stopOutputMonitoring();
  }
}